export default {
  MESSAGE_SHOW: 'MESSAGE_SHOW',
  MESSAGE_HIDE: 'MESSAGE_HIDE',
  MESSAGE_NEXT: 'MESSAGE_NEXT',

  OPEN_CREATE_COMPANY_DIALOG: 'OPEN_CREATE_COMPANY_DIALOG',
  OPEN_EDIT_COMPANY_DIALOG: 'OPEN_EDIT_COMPANY_DIALOG',

  SAMPLE: 'SAMPLE',

  //BRANCH
  OPEN_CREATE_BRANCH_DIALOG: 'OPEN_CREATE_BRANCH_DIALOG',
  OPEN_EDIT_BRANCH_DIALOG: 'OPEN_EDIT_BRANCH_DIALOG',

  CHANGE_SEARCH_TERM_ALL_BRANCH: 'CHANGE_SEARCH_TERM_ALL_BRANCH',

  CHECK_BRANCH_ACCESS_FOR_USER: 'CHECK_BRANCH_ACCESS_FOR_USER',
  START_CHECK_BRANCH_ACCESS_FOR_USER: 'START_CHECK_BRANCH_ACCESS_FOR_USER',
  CHECK_BRANCH_ACCESS_FOR_USER_SUCCESS: 'CHECK_BRANCH_ACCESS_FOR_USER_SUCCESS',
  CHECK_BRANCH_ACCESS_FOR_USER_FAILURE: 'CHECK_BRANCH_ACCESS_FOR_USER_FAILURE',
  CHECK_BRANCH_ACCESS_FOR_USER_FINISHED:
    'CHECK_BRANCH_ACCESS_FOR_USER_FINISHED',

  //LoadBRANCHes
  START_GET_ALL_BRANCH: 'START_GET_ALL_BRANCH',
  GET_ALL_BRANCH: 'GET_ALL_BRANCH',
  GET_ALL_BRANCH_SUCCESS: 'GET_ALL_BRANCH_SUCCESS',
  GET_ALL_BRANCH_FAILURE: 'GET_ALL_BRANCH_FAILURE',
  GET_ALL_BRANCH_FINISH: 'GET_ALL_BRANCH_FINISH',

  INPUT_CHANGE_CREATE_BRANCH_FORM: 'INPUT_CHANGE_CREATE_BRANCH_FORM',

  EDIT_BRANCH: 'EDIT_BRANCH',

  //Create BRANCH
  SUBMIT_BRANCH: 'SUBMIT_BRANCH',
  START_SUBMIT_BRANCH: 'START_SUBMIT_BRANCH',
  SUBMIT_BRANCH_SUCCESS: 'SUBMIT_BRANCH_SUCCESS',
  SUBMIT_BRANCH_FAILURE: 'SUBMIT_BRANCH_FAILURE',
  SUBMIT_BRANCH_FINISHED: 'SUBMIT_BRANCH_FINISHED',

  //Update BRANCH

  DEACTIVATE_OR_DELETE_BRANCH_DIALOG: 'DEACTIVATE_OR_DELETE_BRANCH_DIALOG',
  DEACTIVATE_OR_DELETE_BRANCH: 'DEACTIVATE_OR_DELETE_BRANCH',

  //Companies

  INPUT_CHANGE_CREATE_COMPANY_FORM: 'INPUT_CHANGE_CREATE_COMPANY_FORM',
  DEACTIVATE_OR_DELETE_COMPANY_DIALOG: 'DEACTIVATE_OR_DELETE_COMPANY_DIALOG',

  DEACTIVATE_OR_DELETE_COMPANY: 'DEACTIVATE_OR_DELETE_COMPANY',

  SUBMIT_COMPANY: 'SUBMIT_COMPANY',
  START_SUBMIT_COMPANY: 'START_SUBMIT_COMPANY',
  SUBMIT_COMPANY_SUCCESS: 'SUBMIT_COMPANY_SUCCESS',
  SUBMIT_COMPANY_FAILURE: 'SUBMIT_COMPANY_FAILURE',
  SUBMIT_COMPANY_FINISHED: 'SUBMIT_COMPANY_FINISHED',

  CHANGE_SEARCH_TERM_ALL_COMPANIES: 'CHANGE_SEARCH_TERM_ALL_COMPANIES',

  FETCH_ALL_COMPANIES: 'FETCH_ALL_COMPANIES',
  START_FETCH_ALL_COMPANIES: 'START_FETCH_ALL_COMPANIES',
  FETCH_ALL_COMPANIES_SUCCESS: 'FETCH_ALL_COMPANIES_SUCCESS',
  FETCH_ALL_COMPANIES_FAILURE: 'FETCH_ALL_COMPANIES_FAILURE',
  FETCH_ALL_COMPANIES_FINISHED: 'FETCH_ALL_COMPANIES_FINISHED',

  CHANGE_TAB_VALUE_IN_HEADER: 'CHANGE_TAB_VALUE_IN_HEADER',

  EDIT_COMPANY: 'EDIT_COMPANY',

  OPEN_CHANGE_PASSWORD_DIALOG: 'OPEN_CHANGE_PASSWORD_DIALOG',

  SEND_CHANGE_PASSWORD_REQUEST: 'SEND_CHANGE_PASSWORD_REQUEST',
  START_SEND_CHANGE_PASSWORD_REQUEST: 'START_SEND_CHANGE_PASSWORD_REQUEST',
  SEND_CHANGE_PASSWORD_REQUEST_SUCCESS: 'SEND_CHANGE_PASSWORD_REQUEST_SUCCESS',
  SEND_CHANGE_PASSWORD_REQUEST_FAILURE: 'SEND_CHANGE_PASSWORD_REQUEST_FAILURE',
  SEND_CHANGE_PASSWORD_REQUEST_FINISHED:
    'SEND_CHANGE_PASSWORD_REQUEST_FINISHED',

  SET_LOGGED_IN_USER: 'SET_LOGGED_IN_USER',
  //Personnels
  FETCH_ALL_PERSONNELS: 'FETCH_ALL_PERSONNELS',
  START_FETCH_ALL_PERSONNELS: 'START_FETCH_ALL_PERSONNELS',
  FETCH_ALL_PERSONNELS_SUCCESS: 'FETCH_ALL_PERSONNELS_SUCCESS',
  FETCH_ALL_PERSONNELS_FAILURE: 'FETCH_ALL_PERSONNELS_FAILURE',
  FETCH_ALL_PERSONNELS_FINISHED: 'FETCH_ALL_PERSONNELS_FINISHED',

  OPEN_CREATE_PERSONNEL_DIALOG: 'OPEN_CREATE_PERSONNEL_DIALOG',
  OPEN_EDIT_PERSONNEL_DIALOG: 'OPEN_EDIT_PERSONNEL_DIALOG',

  CHANGE_SEARCH_TERM_ALL_PERSONNELS: 'CHANGE_SEARCH_TERM_ALL_PERSONNELS',

  INPUT_CHANGE_CREATE_PERSONNEL_FORM: 'INPUT_CHANGE_CREATE_PERSONNEL_FORM',

  SUBMIT_PERSONNEL: 'SUBMIT_PERSONNEL',
  START_SUBMIT_PERSONNEL: 'START_SUBMIT_PERSONNEL',
  SUBMIT_PERSONNEL_SUCCESS: 'SUBMIT_PERSONNEL_SUCCESS',
  SUBMIT_PERSONNEL_FAILURE: 'SUBMIT_PERSONNEL_FAILURE',
  SUBMIT_PERSONNEL_FINISHED: 'SUBMIT_PERSONNEL_FINISHED',

  CHANGE_NEW_PERSONNEL_VALIDATION_STATE:
    'CHANGE_NEW_PERSONNEL_VALIDATION_STATE',

  OPEN_DELETE_PERSONNEL_DIALOG: 'OPEN_DELETE_PERSONNEL_DIALOG',
  OPEN_ADD_COURSE_RECORD_DIALOG: 'OPEN_ADD_COURSE_RECORD_DIALOG',
  OPEN_ADD_EVENT_RECORD_DIALOG: 'OPEN_ADD_EVENT_RECORD_DIALOG',
  OPEN_ADD_HAZARD_CONTROL_DIALOG: 'OPEN_ADD_HAZARD_CONTROL_DIALOG',

  FETCH_USER_DETAILS: 'FETCH_USER_DETAILS',
  START_FETCH_USER_DETAILS: 'START_FETCH_USER_DETAILS',
  FETCH_USER_DETAILS_SUCCESS: 'FETCH_USER_DETAILS_SUCCESS',
  FETCH_USER_DETAILS_FAILURE: 'FETCH_USER_DETAILS_FAILURE',
  FETCH_USER_DETAILS_FINISHED: 'FETCH_USER_DETAILS_FINISHED',

  SET_CURRENT_BRANCHES_RECORD: 'SET_CURRENT_BRANCHES_RECORD',
  EDIT_PERSONNEL: 'EDIT_PERSONNEL',

  OPEN_COURSES_FOR_PERSONNEL_DIALOG: 'OPEN_COURSES_FOR_PERSONNEL_DIALOG',
  CLEAR_ALL_COURSES_FOR_PERSONNEL: 'CLEAR_ALL_COURSES_FOR_PERSONNEL',

  FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER:
    'FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER',
  START_FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER:
    'START_FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER',
  FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_SUCCESS:
    'FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_SUCCESS',
  FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FAILURE:
    'FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FAILURE',
  FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FINISHED:
    'FETCH_BRANCH_DETAILS_FOR_LOGGEDIN_USER_FINISHED',

  FETCH_BRANCH_DETAILS_BY_BRANCH_ID: 'FETCH_BRANCH_DETAILS_BY_BRANCH_ID',
  START_FETCH_BRANCH_DETAILS_BY_BRANCH_ID:
    'START_FETCH_BRANCH_DETAILS_BY_BRANCH_ID',
  FETCH_BRANCH_DETAILS_BY_BRANCH_ID_SUCCESS:
    'FETCH_BRANCH_DETAILS_BY_BRANCH_ID_SUCCESS',
  FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FAILURE:
    'FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FAILURE',
  FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FINISHED:
    'FETCH_BRANCH_DETAILS_BY_BRANCH_ID_FINISHED',

  FETCH_ALL_ACCIDENTS_FOR_BRANCH: 'FETCH_ALL_ACCIDENTS_FOR_BRANCH',
  START_FETCH_ALL_ACCIDENTS_FOR_BRANCH: 'START_FETCH_ALL_ACCIDENTS_FOR_BRANCH',
  FETCH_ALL_ACCIDENTS_FOR_BRANCH_SUCCESS:
    'FETCH_ALL_ACCIDENTS_FOR_BRANCH_SUCCESS',
  FETCH_ALL_ACCIDENTS_FOR_BRANCH_FAILURE:
    'FETCH_ALL_ACCIDENTS_FOR_BRANCH_FAILURE',
  FETCH_ALL_ACCIDENTS_FOR_BRANCH_FINISHED:
    'FETCH_ALL_ACCIDENTS_FOR_BRANCH_FINISHED',

  FETCH_ALL_ACCIDENTS_FOR_COMPANY: 'FETCH_ALL_ACCIDENTS_FOR_COMPANY',
  START_FETCH_ALL_ACCIDENTS_FOR_COMPANY:
    'START_FETCH_ALL_ACCIDENTS_FOR_COMPANY',
  FETCH_ALL_ACCIDENTS_FOR_COMPANY_SUCCESS:
    'FETCH_ALL_ACCIDENTS_FOR_COMPANY_SUCCESS',
  FETCH_ALL_ACCIDENTS_FOR_COMPANY_FAILURE:
    'FETCH_ALL_ACCIDENTS_FOR_COMPANY_FAILURE',
  FETCH_ALL_ACCIDENTS_FOR_COMPANY_FINISHED:
    'FETCH_ALL_ACCIDENTS_FOR_COMPANY_FINISHED',

  CHANGE_SEARCH_TERM_ALL_ACCIDENTS: 'CHANGE_SEARCH_TERM_ALL_ACCIDENTS',
  OPEN_CREATE_ACCIDENT_DIALOG: 'OPEN_CREATE_ACCIDENT_DIALOG',
  OPEN_EDIT_ACCIDENT_DIALOG: 'OPEN_EDIT_ACCIDENT_DIALOG',
  INPUT_CHANGE_CREATE_ACCIDENT_FORM: 'INPUT_CHANGE_CREATE_ACCIDENT_FORM',
  EDIT_ACCIDENT: 'EDIT_ACCIDENT',

  DEACTIVATE_OR_DELETE_ACCIDENT_DIALOG: 'DEACTIVATE_OR_DELETE_ACCIDENT_DIALOG',

  DEACTIVATE_OR_DELETE_ACCIDENT: 'DEACTIVATE_OR_DELETE_ACCIDENT',
  START_DEACTIVATE_OR_DELETE_ACCIDENT: 'START_DEACTIVATE_OR_DELETE_ACCIDENT',
  DEACTIVATE_OR_DELETE_ACCIDENT_SUCCESS:
    'DEACTIVATE_OR_DELETE_ACCIDENT_SUCCESS',
  DEACTIVATE_OR_DELETE_ACCIDENT_FAILURE:
    'DEACTIVATE_OR_DELETE_ACCIDENT_FAILURE',
  DEACTIVATE_OR_DELETE_ACCIDENT_FINISHED:
    'DEACTIVATE_OR_DELETE_ACCIDENT_FINISHED',

  SUBMIT_ACCIDENT: 'SUBMIT_ACCIDENT',
  START_SUBMIT_ACCIDENT: 'START_SUBMIT_ACCIDENT',
  SUBMIT_ACCIDENT_SUCCESS: 'SUBMIT_ACCIDENT_SUCCESS',
  SUBMIT_ACCIDENT_FAILURE: 'SUBMIT_ACCIDENT_FAILURE',
  SUBMIT_ACCIDENT_FINISHED: 'SUBMIT_ACCIDENT_FINISHED',

  FETCH_ALL_EVENTS_FOR_BRANCH: 'FETCH_ALL_EVENTS_FOR_BRANCH',
  START_FETCH_ALL_EVENTS_FOR_BRANCH: 'START_FETCH_ALL_EVENTS_FOR_BRANCH',
  FETCH_ALL_EVENTS_FOR_BRANCH_SUCCESS: 'FETCH_ALL_EVENTS_FOR_BRANCH_SUCCESS',
  FETCH_ALL_EVENTS_FOR_BRANCH_FAILURE: 'FETCH_ALL_EVENTS_FOR_BRANCH_FAILURE',
  FETCH_ALL_EVENTS_FOR_BRANCH_FINISHED: 'FETCH_ALL_EVENTS_FOR_BRANCH_FINISHED',

  FETCH_ALL_EVENTS_FOR_COMPANY: 'FETCH_ALL_EVENTS_FOR_COMPANY',
  START_FETCH_ALL_EVENTS_FOR_COMPANY: 'START_FETCH_ALL_EVENTS_FOR_COMPANY',
  FETCH_ALL_EVENTS_FOR_COMPANY_SUCCESS: 'FETCH_ALL_EVENTS_FOR_COMPANY_SUCCESS',
  FETCH_ALL_EVENTS_FOR_COMPANY_FAILURE: 'FETCH_ALL_EVENTS_FOR_COMPANY_FAILURE',
  FETCH_ALL_EVENTS_FOR_COMPANY_FINISHED:
    'FETCH_ALL_EVENTS_FOR_COMPANY_FINISHED',

  CHANGE_SEARCH_TERM_ALL_EVENTS: 'CHANGE_SEARCH_TERM_ALL_EVENTS',
  OPEN_CREATE_EVENT_DIALOG: 'OPEN_CREATE_EVENT_DIALOG',
  OPEN_EDIT_EVENT_DIALOG: 'OPEN_EDIT_EVENT_DIALOG',
  OPEN_EDIT_EVENT_PANEL: 'OPEN_EDIT_EVENT_PANEL',
  INPUT_CHANGE_CREATE_EVENT_FORM: 'INPUT_CHANGE_CREATE_EVENT_FORM',
  EDIT_EVENT: 'EDIT_EVENT',

  SUBMIT_EVENT: 'SUBMIT_EVENT',
  START_SUBMIT_EVENT: 'START_SUBMIT_EVENT',
  SUBMIT_EVENT_SUCCESS: 'SUBMIT_EVENT_SUCCESS',
  SUBMIT_EVENT_FAILURE: 'SUBMIT_EVENT_FAILURE',
  SUBMIT_EVENT_FINISHED: 'SUBMIT_EVENT_FINISHED',

  OPEN_DELETE_EVENT_DIALOG: 'OPEN_DELETE_EVENT_DIALOG',

  DELETE_EVENT: 'DELETE_EVENT',
  START_DELETE_EVENT: 'START_DELETE_EVENT',
  DELETE_EVENT_SUCCESS: 'DELETE_EVENT_SUCCESS',
  DELETE_EVENT_FAILURE: 'DELETE_EVENT_FAILURE',
  DELETE_EVENT_FINISHED: 'DELETE_EVENT_FINISHED',

  FETCH_RECORDS_FOR_THE_EVENT: 'FETCH_RECORDS_FOR_THE_EVENT',
  START_FETCH_RECORDS_FOR_THE_EVENT: 'START_FETCH_RECORDS_FOR_THE_EVENT',
  FETCH_RECORDS_FOR_THE_EVENT_SUCCESS: 'FETCH_RECORDS_FOR_THE_EVENT_SUCCESS',
  FETCH_RECORDS_FOR_THE_EVENT_FAILURE: 'FETCH_RECORDS_FOR_THE_EVENT_FAILURE',
  FETCH_RECORDS_FOR_THE_EVENT_FINISHED: 'FETCH_RECORDS_FOR_THE_EVENT_FINISHED',

  DELETE_EVENT_RECORD: 'DELETE_EVENT_RECORD',
  START_DELETE_EVENT_RECORD: 'START_DELETE_EVENT_RECORD',
  DELETE_EVENT_RECORD_SUCCESS: 'DELETE_EVENT_RECORD_SUCCESS',
  DELETE_EVENT_RECORD_FAILURE: 'DELETE_EVENT_RECORD_FAILURE',
  DELETE_EVENT_RECORD_FINISHED: 'DELETE_EVENT_RECORD_FINISHED',

  SUBMIT_EVENT_RECORD: 'SUBMIT_EVENT_RECORD',
  START_SUBMIT_EVENT_RECORD: 'START_SUBMIT_EVENT_RECORD',
  SUBMIT_EVENT_RECORD_SUCCESS: 'SUBMIT_EVENT_RECORD_SUCCESS',
  SUBMIT_EVENT_RECORD_FAILURE: 'SUBMIT_EVENT_RECORD_FAILURE',
  SUBMIT_EVENT_RECORD_FINISHED: 'SUBMIT_EVENT_RECORD_FINISHED',

  FETCH_ALL_COURSES_FOR_BRANCH: 'FETCH_ALL_COURSES_FOR_BRANCH',
  START_FETCH_ALL_COURSES_FOR_BRANCH: 'START_FETCH_ALL_COURSES_FOR_BRANCH',
  FETCH_ALL_COURSES_FOR_BRANCH_SUCCESS: 'FETCH_ALL_COURSES_FOR_BRANCH_SUCCESS',
  FETCH_ALL_COURSES_FOR_BRANCH_FAILURE: 'FETCH_ALL_COURSES_FOR_BRANCH_FAILURE',
  FETCH_ALL_COURSES_FOR_BRANCH_FINISHED:
    'FETCH_ALL_COURSES_FOR_BRANCH_FINISHED',

  FETCH_ALL_COURSE_RECORDS_FOR_BRANCH: 'FETCH_ALL_COURSE_RECORDS_FOR_BRANCH',
  START_FETCH_ALL_COURSE_RECORDS_FOR_BRANCH:
    'START_FETCH_ALL_COURSE_RECORDS_FOR_BRANCH',
  FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_SUCCESS:
    'FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_SUCCESS',
  FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_FAILURE:
    'FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_FAILURE',
  FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_FINISHED:
    'FETCH_ALL_COURSE_RECORDS_FOR_BRANCH_FINISHED',

  FETCH_ALL_COURSES_FOR_COMPANY: 'FETCH_ALL_COURSES_FOR_COMPANY',
  START_FETCH_ALL_COURSES_FOR_COMPANY: 'START_FETCH_ALL_COURSES_FOR_COMPANY',
  FETCH_ALL_COURSES_FOR_COMPANY_SUCCESS:
    'FETCH_ALL_COURSES_FOR_COMPANY_SUCCESS',
  FETCH_ALL_COURSES_FOR_COMPANY_FAILURE:
    'FETCH_ALL_COURSES_FOR_COMPANY_FAILURE',
  FETCH_ALL_COURSES_FOR_COMPANY_FINISHED:
    'FETCH_ALL_COURSES_FOR_COMPANY_FINISHED',

  FETCH_ALL_COURSE_RECORDS_FOR_COMPANY: 'FETCH_ALL_COURSE_RECORDS_FOR_COMPANY',
  START_FETCH_ALL_COURSE_RECORDS_FOR_COMPANY:
    'START_FETCH_ALL_COURSE_RECORDS_FOR_COMPANY',
  FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_SUCCESS:
    'FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_SUCCESS',
  FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_FAILURE:
    'FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_FAILURE',
  FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_FINISHED:
    'FETCH_ALL_COURSE_RECORDS_FOR_COMPANY_FINISHED',

  CHANGE_SEARCH_TERM_ALL_COURSES: 'CHANGE_SEARCH_TERM_ALL_COURSES',
  OPEN_CREATE_COURSE_DIALOG: 'OPEN_CREATE_COURSE_DIALOG',
  OPEN_EDIT_COURSE_PANEL: 'OPEN_EDIT_COURSE_PANEL',
  INPUT_CHANGE_CREATE_COURSE_FORM: 'INPUT_CHANGE_CREATE_COURSE_FORM',
  EDIT_COURSE: 'EDIT_COURSE',
  INPUT_CHANGE_EDIT_COURSE_RECORD: 'INPUT_CHANGE_EDIT_COURSE_RECORD',
  OPEN_EDIT_COURSE_DIALOG: 'OPEN_EDIT_COURSE_DIALOG',

  SUBMIT_COURSE: 'SUBMIT_COURSE',
  START_SUBMIT_COURSE: 'START_SUBMIT_COURSE',
  SUBMIT_COURSE_SUCCESS: 'SUBMIT_COURSE_SUCCESS',
  SUBMIT_COURSE_FAILURE: 'SUBMIT_COURSE_FAILURE',
  SUBMIT_COURSE_FINISHED: 'SUBMIT_COURSE_FINISHED',

  OPEN_DELETE_COURSE_DIALOG: 'OPEN_DELETE_COURSE_DIALOG',

  DELETE_COURSE: 'DELETE_COURSE',
  START_DELETE_COURSE: 'START_DELETE_COURSE',
  DELETE_COURSE_SUCCESS: 'DELETE_COURSE_SUCCESS',
  DELETE_COURSE_FAILURE: 'DELETE_COURSE_FAILURE',
  DELETE_COURSE_FINISHED: 'DELETE_COURSE_FINISHED',

  FETCH_RECORDS_FOR_THE_COURSE: 'FETCH_RECORDS_FOR_THE_COURSE',
  START_FETCH_RECORDS_FOR_THE_COURSE: 'START_FETCH_RECORDS_FOR_THE_COURSE',
  FETCH_RECORDS_FOR_THE_COURSE_SUCCESS: 'FETCH_RECORDS_FOR_THE_COURSE_SUCCESS',
  FETCH_RECORDS_FOR_THE_COURSE_FAILURE: 'FETCH_RECORDS_FOR_THE_COURSE_FAILURE',
  FETCH_RECORDS_FOR_THE_COURSE_FINISHED:
    'FETCH_RECORDS_FOR_THE_COURSE_FINISHED',

  DELETE_COURSE_RECORD: 'DELETE_COURSE_RECORD',
  START_DELETE_COURSE_RECORD: 'START_DELETE_COURSE_RECORD',
  DELETE_COURSE_RECORD_SUCCESS: 'DELETE_COURSE_RECORD_SUCCESS',
  DELETE_COURSE_RECORD_FAILURE: 'DELETE_COURSE_RECORD_FAILURE',
  DELETE_COURSE_RECORD_FINISHED: 'DELETE_COURSE_RECORD_FINISHED',

  ENABLE_EDIT_COURSE_RECORD: 'ENABLE_EDIT_COURSE_RECORD',
  EDIT_COURSE_RECORD: 'EDIT_COURSE_RECORD',
  START_EDIT_COURSE_RECORD: 'START_EDIT_COURSE_RECORD',
  EDIT_COURSE_RECORD_SUCCESS: 'EDIT_COURSE_RECORD_SUCCESS',
  EDIT_COURSE_RECORD_FAILURE: 'EDIT_COURSE_RECORD_FAILURE',
  EDIT_COURSE_RECORD_FINISHED: 'EDIT_COURSE_RECORD_FINISHED',

  SUBMIT_COURSE_RECORD: 'SUBMIT_COURSE_RECORD',
  START_SUBMIT_COURSE_RECORD: 'START_SUBMIT_COURSE_RECORD',
  SUBMIT_COURSE_RECORD_SUCCESS: 'SUBMIT_COURSE_RECORD_SUCCESS',
  SUBMIT_COURSE_RECORD_FAILURE: 'SUBMIT_COURSE_RECORD_FAILURE',
  SUBMIT_COURSE_RECORD_FINISHED: 'SUBMIT_COURSE_RECORD_FINISHED',

  FETCH_COURSES_FOR_PERSONNEL: 'FETCH_COURSES_FOR_PERSONNEL',
  START_FETCH_COURSES_FOR_PERSONNEL: 'START_FETCH_COURSES_FOR_PERSONNEL',
  FETCH_COURSES_FOR_PERSONNEL_SUCCESS: 'FETCH_COURSES_FOR_PERSONNEL_SUCCESS',
  FETCH_COURSES_FOR_PERSONNEL_FAILURE: 'FETCH_COURSES_FOR_PERSONNEL_FAILURE',
  FETCH_COURSES_FOR_PERSONNEL_FINISHED: 'FETCH_COURSES_FOR_PERSONNEL_FINISHED',

  OPEN_CREATE_USER_DIALOG: 'OPEN_CREATE_USER_DIALOG',
  OPEN_EDIT_USER_DIALOG: 'OPEN_EDIT_USER_DIALOG',
  OPEN_DELETE_USER_DIALOG: 'OPEN_DELETE_USER_DIALOG',

  CHANGE_SEARCH_TERM_ALL_USERS: 'CHANGE_SEARCH_TERM_ALL_USERS',

  FETCH_ALL_USERS: 'FETCH_ALL_USERS',
  START_FETCH_ALL_USERS: 'START_FETCH_ALL_USERS',
  FETCH_ALL_USERS_SUCCESS: 'FETCH_ALL_USERS_SUCCESS',
  FETCH_ALL_USERS_FAILURE: 'FETCH_ALL_USERS_FAILURE',
  FETCH_ALL_USERS_FINISHED: 'FETCH_ALL_USERS_FINISHED',

  EDIT_USER: 'EDIT_USER',

  INPUT_CHANGE_CREATE_USER_FORM: 'INPUT_CHANGE_CREATE_USER_FORM',

  SUBMIT_USER: 'SUBMIT_USER',
  START_SUBMIT_USER: 'START_SUBMIT_USER',
  SUBMIT_USER_SUCCESS: 'SUBMIT_USER_SUCCESS',
  SUBMIT_USER_FAILURE: 'SUBMIT_USER_FAILURE',
  SUBMIT_USER_FINISHED: 'SUBMIT_USER_FINISHED',

  ENABLE_EDIT_EVENT_RECORD: 'ENABLE_EDIT_EVENT_RECORD',
  EDIT_EVENT_RECORD: 'EDIT_EVENT_RECORD',
  START_EDIT_EVENT_RECORD: 'START_EDIT_EVENT_RECORD',
  EDIT_EVENT_RECORD_SUCCESS: 'EDIT_EVENT_RECORD_SUCCESS',
  EDIT_EVENT_RECORD_FAILURE: 'EDIT_EVENT_RECORD_FAILURE',
  EDIT_EVENT_RECORD_FINISHED: 'EDIT_EVENT_RECORD_FINISHED',

  INPUT_CHANGE_EDIT_EVENT_RECORD: 'INPUT_CHANGE_EDIT_EVENT_RECORD',

  //hazards
  FETCH_ALL_HAZARDS_FOR_BRANCH: 'FETCH_ALL_HAZARDS_FOR_BRANCH',
  START_FETCH_ALL_HAZARDS_FOR_BRANCH: 'START_FETCH_ALL_HAZARDS_FOR_BRANCH',
  FETCH_ALL_HAZARDS_FOR_BRANCH_SUCCESS: 'FETCH_ALL_HAZARDS_FOR_BRANCH_SUCCESS',
  FETCH_ALL_HAZARDS_FOR_BRANCH_FAILURE: 'FETCH_ALL_HAZARDS_FOR_BRANCH_FAILURE',
  FETCH_ALL_HAZARDS_FOR_BRANCH_FINISHED:
    'FETCH_ALL_HAZARDS_FOR_BRANCH_FINISHED',

  FETCH_ALL_HAZARDS_FOR_COMPANY: 'FETCH_ALL_HAZARDS_FOR_COMPANY',
  START_FETCH_ALL_HAZARDS_FOR_COMPANY: 'START_FETCH_ALL_HAZARDS_FOR_COMPANY',
  FETCH_ALL_HAZARDS_FOR_COMPANY_SUCCESS:
    'FETCH_ALL_HAZARDS_FOR_COMPANY_SUCCESS',
  FETCH_ALL_HAZARDS_FOR_COMPANY_FAILURE:
    'FETCH_ALL_HAZARDS_FOR_COMPANY_FAILURE',
  FETCH_ALL_HAZARDS_FOR_COMPANY_FINISHED:
    'FETCH_ALL_HAZARDS_FOR_COMPANY_FINISHED',

  CHANGE_SEARCH_TERM_ALL_HAZARDS: 'CHANGE_SEARCH_TERM_ALL_HAZARDS',
  OPEN_CREATE_HAZARD_DIALOG: 'OPEN_CREATE_HAZARD_DIALOG',
  OPEN_EDIT_HAZARD_DIALOG: 'OPEN_EDIT_HAZARD_DIALOG',
  OPEN_EDIT_HAZARD_PANEL: 'OPEN_EDIT_HAZARD_PANEL',
  INPUT_CHANGE_CREATE_HAZARD_FORM: 'INPUT_CHANGE_CREATE_HAZARD_FORM',
  EDIT_HAZARD: 'EDIT_HAZARD',

  SUBMIT_HAZARD: 'SUBMIT_HAZARD',
  START_SUBMIT_HAZARD: 'START_SUBMIT_HAZARD',
  SUBMIT_HAZARD_SUCCESS: 'SUBMIT_HAZARD_SUCCESS',
  SUBMIT_HAZARD_FAILURE: 'SUBMIT_HAZARD_FAILURE',
  SUBMIT_HAZARD_FINISHED: 'SUBMIT_HAZARD_FINISHED',

  OPEN_DELETE_HAZARD_DIALOG: 'OPEN_DELETE_HAZARD_DIALOG',

  DELETE_HAZARD: 'DELETE_HAZARD',
  START_DELETE_HAZARD: 'START_DELETE_HAZARD',
  DELETE_HAZARD_SUCCESS: 'DELETE_HAZARD_SUCCESS',
  DELETE_HAZARD_FAILURE: 'DELETE_HAZARD_FAILURE',
  DELETE_HAZARD_FINISHED: 'DELETE_HAZARD_FINISHED',

  FETCH_CONTROLS_FOR_THE_HAZARD: 'FETCH_CONTROLS_FOR_THE_HAZARD',
  START_FETCH_CONTROLS_FOR_THE_HAZARD: 'START_FETCH_CONTROLS_FOR_THE_HAZARD',
  FETCH_CONTROLS_FOR_THE_HAZARD_SUCCESS:
    'FETCH_CONTROLS_FOR_THE_HAZARD_SUCCESS',
  FETCH_CONTROLS_FOR_THE_HAZARD_FAILURE:
    'FETCH_CONTROLS_FOR_THE_HAZARD_FAILURE',
  FETCH_CONTROLS_FOR_THE_HAZARD_FINISHED:
    'FETCH_CONTROLS_FOR_THE_HAZARD_FINISHED',

  DELETE_HAZARD_CONTROL: 'DELETE_HAZARD_CONTROL',
  START_DELETE_HAZARD_CONTROL: 'START_DELETE_HAZARD_CONTROL',
  DELETE_HAZARD_CONTROL_SUCCESS: 'DELETE_HAZARD_CONTROL_SUCCESS',
  DELETE_HAZARD_CONTROL_FAILURE: 'DELETE_HAZARD_CONTROL_FAILURE',
  DELETE_HAZARD_CONTROL_FINISHED: 'DELETE_HAZARD_CONTROL_FINISHED',

  SUBMIT_HAZARD_CONTROL: 'SUBMIT_HAZARD_CONTROL',
  START_SUBMIT_HAZARD_CONTROL: 'START_SUBMIT_HAZARD_CONTROL',
  SUBMIT_HAZARD_CONTROL_SUCCESS: 'SUBMIT_HAZARD_CONTROL_SUCCESS',
  SUBMIT_HAZARD_CONTROL_FAILURE: 'SUBMIT_HAZARD_CONTROL_FAILURE',
  SUBMIT_HAZARD_CONTROL_FINISHED: 'SUBMIT_HAZARD_CONTROL_FINISHED',

  ENABLE_EDIT_HAZARD_CONTROL: 'ENABLE_EDIT_HAZARD_CONTROL',
  EDIT_HAZARD_CONTROL: 'EDIT_HAZARD_CONTROL',
  START_EDIT_HAZARD_CONTROL: 'START_EDIT_HAZARD_CONTROL',
  EDIT_HAZARD_CONTROL_SUCCESS: 'EDIT_HAZARD_CONTROL_SUCCESS',
  EDIT_HAZARD_CONTROL_FAILURE: 'EDIT_HAZARD_CONTROL_FAILURE',
  EDIT_HAZARD_CONTROL_FINISHED: 'EDIT_HAZARD_CONTROL_FINISHED',

  INPUT_CHANGE_EDIT_HAZARD_CONTROL: 'INPUT_CHANGE_EDIT_HAZARD_CONTROL',

  OPEN_DELETE_HAZARD_CONTROL_DIALOG: 'OPEN_DELETE_HAZARD_CONTROL_DIALOG',

  //HAZARD REVIEW

  OPEN_HAZARD_REVIEW_PANEL: 'OPEN_HAZARD_REVIEW_PANEL',

  FETCH_REVIEWS_FOR_THE_HAZARD: 'FETCH_REVIEWS_FOR_THE_HAZARD',
  START_FETCH_REVIEWS_FOR_THE_HAZARD: 'START_FETCH_REVIEWS_FOR_THE_HAZARD',
  FETCH_REVIEWS_FOR_THE_HAZARD_SUCCESS: 'FETCH_REVIEWS_FOR_THE_HAZARD_SUCCESS',
  FETCH_REVIEWS_FOR_THE_HAZARD_FAILURE: 'FETCH_REVIEWS_FOR_THE_HAZARD_FAILURE',
  FETCH_REVIEWS_FOR_THE_HAZARD_FINISHED:
    'FETCH_REVIEWS_FOR_THE_HAZARD_FINISHED',

  OPEN_CREATE_HAZARD_REVIEW_DIALOG: 'OPEN_CREATE_HAZARD_REVIEW_DIALOG',

  SUBMIT_HAZARD_REVIEW: 'SUBMIT_HAZARD_REVIEW',
  START_SUBMIT_HAZARD_REVIEW: 'START_SUBMIT_HAZARD_REVIEW',
  SUBMIT_HAZARD_REVIEW_SUCCESS: 'SUBMIT_HAZARD_REVIEW_SUCCESS',
  SUBMIT_HAZARD_REVIEW_FAILURE: 'SUBMIT_HAZARD_REVIEW_FAILURE',
  SUBMIT_HAZARD_REVIEW_FINISHED: 'SUBMIT_HAZARD_REVIEW_FINISHED',

  INPUT_CHANGE_EDIT_HAZARD_REVIEW: 'INPUT_CHANGE_EDIT_HAZARD_REVIEW',

  INPUT_CHANGE_ADD_HAZARD_REVIEW: 'INPUT_CHANGE_ADD_HAZARD_REVIEW',

  ENABLE_EDIT_HAZARD_REVIEW: 'ENABLE_EDIT_HAZARD_REVIEW',
  EDIT_HAZARD_REVIEW: 'EDIT_HAZARD_REVIEW',
  START_EDIT_HAZARD_REVIEW: 'START_EDIT_HAZARD_REVIEW',
  EDIT_HAZARD_REVIEW_SUCCESS: 'EDIT_HAZARD_REVIEW_SUCCESS',
  EDIT_HAZARD_REVIEW_FAILURE: 'EDIT_HAZARD_REVIEW_FAILURE',
  EDIT_HAZARD_REVIEW_FINISHED: 'EDIT_HAZARD_REVIEW_FINISHED',

  OPEN_DELETE_HAZARD_REVIEW_DIALOG: 'OPEN_DELETE_HAZARD_REVIEW_DIALOG',

  //HAZARD ManagementLogs

  OPEN_HAZARD_MANAGEMENTLOG_PANEL: 'OPEN_HAZARD_MANAGEMENTLOG_PANEL',

  FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD: 'FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD',
  START_FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD:
    'START_FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD',
  FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_SUCCESS:
    'FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_SUCCESS',
  FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_FAILURE:
    'FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_FAILURE',
  FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_FINISHED:
    'FETCH_MANAGEMENT_LOGS_FOR_THE_HAZARD_FINISHED',

  OPEN_CREATE_HAZARD_MANAGEMENT_LOG_DIALOG:
    'OPEN_CREATE_HAZARD_MANAGEMENT_LOG_DIALOG',

  SUBMIT_HAZARD_MANAGEMENT_LOG: 'SUBMIT_HAZARD_MANAGEMENT_LOG',
  START_SUBMIT_HAZARD_MANAGEMENT_LOG: 'START_SUBMIT_HAZARD_MANAGEMENT_LOG',
  SUBMIT_HAZARD_MANAGEMENT_LOG_SUCCESS: 'SUBMIT_HAZARD_MANAGEMENT_LOG_SUCCESS',
  SUBMIT_HAZARD_MANAGEMENT_LOG_FAILURE: 'SUBMIT_HAZARD_MANAGEMENT_LOG_FAILURE',
  SUBMIT_HAZARD_MANAGEMENT_LOG_FINISHED:
    'SUBMIT_HAZARD_MANAGEMENT_LOG_FINISHED',

  INPUT_CHANGE_EDIT_HAZARD_MANAGEMENT_LOG:
    'INPUT_CHANGE_EDIT_HAZARD_MANAGEMENT_LOG',

  INPUT_CHANGE_ADD_HAZARD_MANAGEMENT_LOG:
    'INPUT_CHANGE_ADD_HAZARD_MANAGEMENT_LOG',

  ENABLE_EDIT_HAZARD_MANAGEMENT_LOG: 'ENABLE_EDIT_HAZARD_MANAGEMENT_LOG',
  EDIT_HAZARD_MANAGEMENT_LOG: 'EDIT_HAZARD_MANAGEMENT_LOG',
  START_EDIT_HAZARD_MANAGEMENT_LOG: 'START_HAZARD_MANAGEMENT_LOG',
  EDIT_HAZARD_MANAGEMENT_LOG_SUCCESS: 'EDIT_HAZARD_MANAGEMENT_LOG_SUCCESS',
  EDIT_HAZARD_MANAGEMENT_LOG_FAILURE: 'EDIT_HAZARD_MANAGEMENT_LOG_FAILURE',
  EDIT_HAZARD_MANAGEMENT_LOG_FINISHED: 'EDIT_HAZARD_MANAGEMENT_LOG_FINISHED',

  OPEN_DELETE_HAZARD_MANAGEMENT_LOG_DIALOG:
    'OPEN_DELETE_HAZARD_MANAGEMENT_LOG_DIALOG',

  FETCH_ALL_REVIEWS_FOR_BRANCH: 'FETCH_ALL_REVIEWS_FOR_BRANCH',
  EDIT_REVIEW: 'EDIT_REVIEW',

  CHANGE_SELECTED_HAZARD_STATUS_FILTER: 'CHANGE_SELECTED_HAZARD_STATUS_FILTER',
  CHANGE_SELECTED_HAZARD_DESCRIPTION_FILTER:
    'CHANGE_SELECTED_HAZARD_DESCRIPTION_FILTER',

  CLEAR_HAZARD_FILTERS: 'CLEAR_HAZARD_FILTERS',

  FETCH_ALL_DOCUMENTS: 'FETCH_ALL_DOCUMENTS',
  START_FETCH_ALL_DOCUMENTS: 'START_FETCH_ALL_DOCUMENTS',
  FETCH_ALL_DOCUMENTS_SUCCESS: 'FETCH_ALL_DOCUMENTS_SUCCESS',
  FETCH_ALL_DOCUMENTS_FAILURE: 'FETCH_ALL_DOCUMENTS_FAILURE',
  FETCH_ALL_DOCUMENTS_FINISHED: 'FETCH_ALL_DOCUMENTS_FINISHED',

  OPEN_DOCUMENT_LIST_DIALOG: 'OPEN_DOCUMENT_LIST_DIALOG',
  DOCUMENT_SHOW_FOLDER_ITEMS: 'DOCUMENT_SHOW_FOLDER_ITEMS',
  DOCUMENT_BACK_ARROW_CLICKED: 'DOCUMENT_BACK_ARROW_CLICKED',
  DOCUMENT_RESET_ORIGINAL_STATE: 'DOCUMENT_RESET_ORIGINAL_STATE',
  DOCUMENT_SELECTED: 'DOCUMENT_SELECTED',

  FULL_RESET_DOCUMENTS:'FULL_RESET_DOCUMENTS',

  FETCH_ALL_DOCUMENTS_FOR_BRANCH: 'FETCH_ALL_DOCUMENTS_FOR_BRANCH',

  //HAZARD ATTACHMENT
  LOAD_ATTACHMENTS_FOR_HAZARD: 'LOAD_ATTACHMENTS_FOR_HAZARD',
  START_LOAD_ATTACHMENTS_FOR_HAZARD: 'START_LOAD_ATTACHMENTS_FOR_HAZARD',
  LOAD_ATTACHMENTS_FOR_HAZARD_SUCCESS: 'LOAD_ATTACHMENTS_FOR_HAZARD_SUCCESS',
  LOAD_ATTACHMENTS_FOR_HAZARD_FAILURE: 'LOAD_ATTACHMENTS_FOR_HAZARD_FAILURE',
  LOAD_ATTACHMENTS_FOR_HAZARD_FINISHED: 'LOAD_ATTACHMENTS_FOR_HAZARD_FINISHED',

  REMOVE_HAZARD_ATTACHMENT: 'REMOVE_HAZARD_ATTACHMENT',

  UPLOAD_ATTACHMENTS_FOR_HAZARD: 'UPLOAD_ATTACHMENTS_FOR_HAZARD',
  START_UPLOAD_ATTACHMENTS_FOR_HAZARD: 'START_UPLOAD_ATTACHMENTS_FOR_HAZARD',
  UPLOAD_ATTACHMENTS_FOR_HAZARD_SUCCESS:
    'UPLOAD_ATTACHMENTS_FOR_HAZARD_SUCCESS',
  UPLOAD_ATTACHMENTS_FOR_HAZARD_FAILURE:
    'UPLOAD_ATTACHMENTS_FOR_HAZARD_FAILURE',
  UPLOAD_ATTACHMENTS_FOR_HAZARD_FINISHED:
    'UPLOAD_ATTACHMENTS_FOR_HAZARD_FINISHED',

  DELETE_ATTACHMENTS_FOR_HAZARD: 'DELETE_ATTACHMENTS_FOR_HAZARD',

  //Course Record Attachment
  REMOVE_COURSE_RECORD_ATTACHMENT: 'REMOVE_COURSE_RECORD_ATTACHMENT',
  REMOVE_COURSE_RECORD_ATTACHMENT_EDIT: 'REMOVE_COURSE_RECORD_ATTACHMENT_EDIT',
  LOAD_ATTACHMENTS_FOR_COURSE_RECORD: 'LOAD_ATTACHMENTS_FOR_COURSE_RECORD',

  UPLOAD_ATTACHMENTS_FOR_COURSE_RECORD: 'UPLOAD_ATTACHMENTS_FOR_COURSE_RECORD',
  DELETE_ATTACHMENTS_FOR_COURSE_RECORD: 'DELETE_ATTACHMENTS_FOR_COURSE_RECORD',

  START_LOAD_ATTACHMENTS_FOR_COURSE_RECORD:
    'START_LOAD_ATTACHMENTS_FOR_COURSE_RECORD',
  LOAD_ATTACHMENTS_FOR_COURSE_RECORD_SUCCESS:
    'LOAD_ATTACHMENTS_FOR_COURSE_RECORD_SUCCESS',
  LOAD_ATTACHMENTS_FOR_COURSE_RECORD_FAILURE:
    'LOAD_ATTACHMENTS_FOR_COURSE_RECORD_FAILURE',
  LOAD_ATTACHMENTS_FOR_COURSE_RECORD_FINISHED:
    'LOAD_ATTACHMENTS_FOR_COURSE_RECORD_FINISHED',

  //Event Record Attachment
  REMOVE_EVENT_RECORD_ATTACHMENT: 'REMOVE_EVENT_RECORD_ATTACHMENT',
  REMOVE_EVENT_RECORD_ATTACHMENT_EDIT: 'REMOVE_EVENT_RECORD_ATTACHMENT_EDIT',
  LOAD_ATTACHMENTS_FOR_EVENT_RECORD: 'LOAD_ATTACHMENTS_FOR_EVENT_RECORD',

  UPLOAD_ATTACHMENTS_FOR_EVENT_RECORD: 'UPLOAD_ATTACHMENTS_FOR_EVENT_RECORD',
  DELETE_ATTACHMENTS_FOR_EVENT_RECORD: 'DELETE_ATTACHMENTS_FOR_EVENT_RECORD',

  START_LOAD_ATTACHMENTS_FOR_EVENT_RECORD:
    'START_LOAD_ATTACHMENTS_FOR_EVENT_RECORD',
  LOAD_ATTACHMENTS_FOR_EVENT_RECORD_SUCCESS:
    'LOAD_ATTACHMENTS_FOR_EVENT_RECORD_SUCCESS',
  LOAD_ATTACHMENTS_FOR_EVENT_RECORD_FAILURE:
    'LOAD_ATTACHMENTS_FOR_EVENT_RECORD_FAILURE',
  LOAD_ATTACHMENTS_FOR_EVENT_RECORD_FINISHED:
    'LOAD_ATTACHMENTS_FOR_EVENT_RECORD_FINISHED',

  //Accident Attachement
  LOAD_ATTACHMENTS_FOR_ACCIDENT: 'LOAD_ATTACHMENTS_FOR_ACCIDENT',
  START_LOAD_ATTACHMENTS_FOR_ACCIDENT: 'START_LOAD_ATTACHMENTS_FOR_ACCIDENT',
  LOAD_ATTACHMENTS_FOR_ACCIDENT_SUCCESS:
    'LOAD_ATTACHMENTS_FOR_ACCIDENT_SUCCESS',
  LOAD_ATTACHMENTS_FOR_ACCIDENT_FAILURE:
    'LOAD_ATTACHMENTS_FOR_ACCIDENT_FAILURE',
  LOAD_ATTACHMENTS_FOR_ACCIDENT_FINISHED:
    'LOAD_ATTACHMENTS_FOR_ACCIDENT_FINISHED',

  REMOVE_ACCIDENT_ATTACHMENT: 'REMOVE_ACCIDENT_ATTACHMENT',

  UPLOAD_ATTACHMENTS_FOR_ACCIDENT: 'UPLOAD_ATTACHMENTS_FOR_ACCIDENT',
  DELETE_ATTACHMENTS_FOR_ACCIDENT: 'DELETE_ATTACHMENTS_FOR_ACCIDENT',

  //Hazard Review Attachment
  REMOVE_HAZARD_REVIEW_ATTACHMENT: 'REMOVE_HAZARD_REVIEW_ATTACHMENT',
  LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW: 'LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW',
  REMOVE_HAZARD_REVIEW_ATTACHMENT_EDIT: 'REMOVE_HAZARD_REVIEW_ATTACHMENT_EDIT',

  UPLOAD_ATTACHMENTS_FOR_HAZARD_REVIEW: 'UPLOAD_ATTACHMENTS_FOR_HAZARD_REVIEW',
  DELETE_ATTACHMENTS_FOR_HAZARD_REVIEW: 'DELETE_ATTACHMENTS_FOR_HAZARD_REVIEW',

  START_LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW:
    'START_LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW',
  LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_SUCCESS:
    'LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_SUCCESS',
  LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_FAILURE:
    'LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_FAILURE',
  LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_FINISHED:
    'LOAD_ATTACHMENTS_FOR_HAZARD_REVIEW_FINISHED',

  //Hazard Management logs attachment

  REMOVE_HAZARD_MANAGEMENT_LOGS_ATTACHMENT:
    'REMOVE_HAZARD_MANAGEMENT_LOGS_ATTACHMENT',
  LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS:
    'LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS',
  REMOVE_HAZARD_MANAGE_LOGS_ATTACHMENT_EDIT:
    'REMOVE_HAZARD_MANAGE_LOGS_ATTACHMENT_EDIT',

  UPLOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS:
    'UPLOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS',
  DELETE_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS:
    'DELETE_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS',

  START_LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS:
    'START_LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS',
  LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_SUCCESS:
    'LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_SUCCESS',
  LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_FAILURE:
    'LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_FAILURE',
  LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_FINISHED:
    'LOAD_ATTACHMENTS_FOR_HAZARD_MANAGEMENT_LOGS_FINISHED',

  //Hazard Control Attachment
  REMOVE_HAZARD_CONTROL_ATTACHMENT: 'REMOVE_HAZARD_CONTROL_ATTACHMENT',
  LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL: 'LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL',
  REMOVE_HAZARD_CONTROL_ATTACHMENT_EDIT:
    'REMOVE_HAZARD_CONTROL_ATTACHMENT_EDIT',

  UPLOAD_ATTACHMENTS_FOR_HAZARD_CONTROL:
    'UPLOAD_ATTACHMENTS_FOR_HAZARD_CONTROL',
  DELETE_ATTACHMENTS_FOR_HAZARD_CONTROL:
    'DELETE_ATTACHMENTS_FOR_HAZARD_CONTROL',

  START_LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL:
    'START_LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL',
  LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_SUCCESS:
    'LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_SUCCESS',
  LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_FAILURE:
    'LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_FAILURE',
  LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_FINISHED:
    'LOAD_ATTACHMENTS_FOR_HAZARD_CONTROL_FINISHED',



    FOLDER_ADDED: 'FOLDER_ADDED',

    USER_ATTACHMENT_ADD : 'USER_ATTACHMENT_ADD',
    START_USER_ATTACHMENT_ADD:
    'START_USER_ATTACHMENT_ADD',
    USER_ATTACHMENT_ADD_SUCCESS:
    'USER_ATTACHMENT_ADD_SUCCESS',
    USER_ATTACHMENT_ADD_FAILURE:
    'USER_ATTACHMENT_ADD_FAILURE',
    USER_ATTACHMENT_ADD_FINISHED:
    'USER_ATTACHMENT_ADD_FINISHED',


    USER_ATTACHMENT_REMOVE : 'USER_ATTACHMENT_REMOVE',
    START_USER_ATTACHMENT_REMOVE:
    'START_USER_ATTACHMENT_REMOVE',
    USER_ATTACHMENT_REMOVE_SUCCESS:
    'USER_ATTACHMENT_REMOVE_SUCCESS',
    USER_ATTACHMENT_REMOVE_FAILURE:
    'USER_ATTACHMENT_REMOVE_FAILURE',
    USER_ATTACHMENT_REMOVE_FINISHED:
    'USER_ATTACHMENT_REMOVE_FINISHED',

    
};
